<template>
  <modal
    v-bind="$attrs"
    v-on="$listeners"
    :errors="errors"
    :title="$t('verify_facebook_info_modal.title')"
  >
    <template v-slot:header >
    </template>
    <template v-slot:body>
      <el-form :model="form" :rules="rules" ref="form" class="auth-form">
        <upload />
        <elsa-input
          name="firstName"
          :disabled="true"
          :label="$t('verify_facebook_info_modal.first_name_field.label')"
          :placeholder="$t('verify_facebook_info_modal.first_name_field.placeholder')"
          v-model.lazy="form.firstName"
        />
        <elsa-input
          name="lastName"
          :disabled="true"
          :label="$t('verify_facebook_info_modal.last_name_field.label')"
          :placeholder="$t('verify_facebook_info_modal.last_name_field.placeholder')"
          v-model.lazy="form.lastName"
        />
        <elsa-input
          name="email"
          :disabled="true"
          :label="$t('verify_facebook_info_modal.email_field.label')"
          :placeholder="$t('verify_facebook_info_modal.email_field.placeholder')"
          v-model.trim.lazy="form.email"
        />
      </el-form>
    </template>
    <template v-slot:footer>
      <primary-button
        @click.native="handleVerifyInfo"
        ref="submit"
      >
        {{ $t('verify_facebook_info_modal.save_continue') }}
      </primary-button>
    </template>
  </modal>
</template>

<script>
  import Modal from '@/components/common/Modal'
  import PrimaryButton from '@/components/common/buttons/PrimaryButton'
  import ElsaInput from '@/components/common/Input'
  import Upload from '@/components/common/Upload'
  import { handleFormValidation, handleSubmitButtonState, isPropEmpty } from '@/helpers/formValidationHelper'
  import { mapActions } from 'vuex'
  import { prop, compose, propOr, split, last, head } from 'ramda'
  import { firebaseAuth } from '../../../utils/firebase'

  export default {
    components: {
      Modal,
      PrimaryButton,
      ElsaInput,
      Upload
    },
    props: ['verifyInfoData'],
    data() {
      return {
        errors: null,
        form: {},
        rules: {
          email: { type: 'email', message: this.$t('verify_facebook_info_modal.email_field.validation_msg'), trigger: ['blur'] }
        }
      }
    },
    methods: {
      handleVerifyInfo() {
        return handleFormValidation(this.$refs.form, this.handleSuccess, this.handleError)
      },
      handleError(errors) {
        this.errors = errors
      },
      async handleSuccess() {
        const userData = {
          first_name: this.form.firstName,
          last_name: this.form.lastName,
          email: this.form.email,
        }
        try {
          await this.$axios.post('/v1/accounts/sign_in', userData)
          const userToken = await firebaseAuth.currentUser.getIdToken(true)
          await this.$store.dispatch('auth/successLoginCallBack', { userToken })
        } catch(errors) {
          return this.errors = errors
        }

        const token = this.form.token
        if(token) {
          const organizationName = this.form.organizationName
          this.$store.dispatch('invite/acceptInvite', { token })
          .then(() => {
            this.$store.dispatch('invite/addInviteNotification', {
              organizationName,
              success: true,
            })
          })
          .catch(() => {
            this.$store.dispatch('invite/addInviteNotification', {
              organizationName: this.getOrganizationInviteName,
              success: false,
            })
          })
        }

        this.$store.dispatch('auth/login')
        return this.$router.push('/')
      },
      onFormChange() {
        // const isValid = isPropEmpty("firstName")(this.form) || isPropEmpty("lastName")(this.form) || isPropEmpty("email")(this.form)
        const isValid = isPropEmpty("firstName")(this.form) || isPropEmpty("lastName")(this.form)
        handleSubmitButtonState(this.$refs.submit.$el, !isValid)
      },
      ...mapActions({
        updateUserData: 'user/updateUserData',
        updateCurrentUserId: 'user/updateCurrentUserId',
      })
    },
    watch: {
      verifyInfoData: {
        deep: true,
        handler(newValue) {
          const firstName = compose(
            head,
            split(' '),
            propOr([], 'displayName')
          )(newValue)
          const lastName = compose(
            last,
            split(' '),
            propOr([], 'displayName')
          )(newValue)
          const email = prop('email', newValue)
          const phone = prop('phoneNumber', newValue)
          const token = prop('token', newValue)

          this.form = {
            firstName,
            lastName,
            email,
            phone,
            token,
          }
        }
      },
      form: {
        deep: true,
        handler() {
          return this.onFormChange()
        }
      }
    },
  }
</script>

<style lang="scss" scoped>
  .elsa-button {
    width: 202px;
  }

  .el-form .el-form-item:first-of-type {
    margin-bottom: 40px;
  }

  .auth-form .elsa-input {
    margin-bottom: 20px
  }
</style>
